import { c as _c } from "react/compiler-runtime";
import { getMDXComponents } from '@/mdx-components';
import type { MDXComponents } from 'mdx/types';
import { MDXRemote, MDXRemoteProps } from 'next-mdx-remote/rsc';
import rehypeSlug from 'rehype-slug';
import remarkGfm from 'remark-gfm';
interface MDXContentProps {
  source: string;
  components?: MDXComponents;
}

/**
 * Render MDX content from a string source (e.g., from database)
 * This component uses next-mdx-remote to compile and render MDX at runtime
 */
export async function MDXContent(t0) {
  const $ = _c(6);
  const {
    source,
    components
  } = t0;
  let t1;
  if ($[0] !== components) {
    t1 = getMDXComponents(components);
    $[0] = components;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const mdxComponents = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mdxOptions: {
        remarkPlugins: [remarkGfm],
        rehypePlugins: [rehypeSlug]
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== mdxComponents || $[4] !== source) {
    t3 = <MDXRemote source={source} components={mdxComponents} options={t2} />;
    $[3] = mdxComponents;
    $[4] = source;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}